import { Point } from './point'
import { Size } from './size'
import { add, Vector } from './vector'
import { gt, lt } from './util'

export class Rectangle {
  /** corner of the rectangle that extends out in opposite direction of the origin */
  readonly p1: Point

  /**
   * @param p0 corner of the rectangle that extends out in same direction as the corner of the origin
   * @param size size of the rectangle
   */
  constructor(readonly p0: Point, readonly size: Size) {
    // corner of the rectangle farthest of the origin
    this.p1 = add(this.p0,  new Vector(size.width-1, size.height-1))
  }

  within(p: Point): boolean {
    return gt(p.x, this.p0.x) && gt(p.y, this.p0.y) && lt(p.x, this.p1.x) && lt(p.y, this.p1.y)
  }
}